/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Collections_Mostpopular2Inputs */

const id_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terpopuler`)
};

const ms_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling Popular`)
};

const da_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest populære`)
};

const de_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beliebteste`)
};

const en_us2_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Popular`)
};

const es_es2_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más populares`)
};

const es_mx2_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más populares`)
};

const fil_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakasikat`)
};

const fr_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les plus populaires`)
};

const it_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più popolari`)
};

const hu_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legnépszerűbb`)
};

const nl_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meest populair`)
};

const no_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest populære`)
};

const pl_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpopularniejsze`)
};

const pt_br2_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais populares`)
};

const pt_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais populares`)
};

const ro_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai populare`)
};

const fi_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suosituimmat`)
};

const sv_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest populära`)
};

const vi_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phổ biến nhất`)
};

const tr_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Popüler`)
};

const cs_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejoblíbenější`)
};

const bg_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-популярни`)
};

const ru_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самые популярные`)
};

const uk_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найпопулярніше`)
};

const ar_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر شعبية`)
};

const hi_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबसे लोकप्रिय`)
};

const th_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ได้รับความนิยมมากที่สุด`)
};

const ja_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も人気`)
};

const zh_cn2_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最受欢迎`)
};

const zh_hant1_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最受歡迎`)
};

const ko_components_performancetable_collections_mostpopular2 = /** @type {(inputs: Components_Performancetable_Collections_Mostpopular2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가장 인기 있음`)
};

/**
* | output |
* | --- |
* | "Most Popular" |
*
* @param {Components_Performancetable_Collections_Mostpopular2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_collections_mostpopular2 = /** @type {((inputs?: Components_Performancetable_Collections_Mostpopular2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Collections_Mostpopular2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "ms") return ms_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "da") return da_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "de") return de_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "fil") return fil_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "fr") return fr_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "it") return it_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "hu") return hu_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "nl") return nl_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "no") return no_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "pl") return pl_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "pt") return pt_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "ro") return ro_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "fi") return fi_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "sv") return sv_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "vi") return vi_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "tr") return tr_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "cs") return cs_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "bg") return bg_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "ru") return ru_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "uk") return uk_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "ar") return ar_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "hi") return hi_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "th") return th_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "ja") return ja_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_collections_mostpopular2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_collections_mostpopular2(inputs)
	return ko_components_performancetable_collections_mostpopular2(inputs)
});
export { components_performancetable_collections_mostpopular2 as "components.performanceTable.collections.mostPopular" }